
import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { FnMenuDataService } from './../menu/service/fn-menu-data.service';
import { Subscription } from 'rxjs/internal/Subscription';

@Component({
	selector: 'fn-title-header',
	templateUrl: './fn-title-header.component.html',
	styleUrls: ['./fn-title-header.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class FnTitleHeaderComponent implements OnInit, OnDestroy {

	private menuSubscription:Subscription;
	constructor(private menuDataSvcs: FnMenuDataService) {
  }
	activeMenu: any;
	ngOnInit() {
	this.menuSubscription =	this.menuDataSvcs.getActiveMenuId$().subscribe(menuId =>{
			this.activeMenu = this.menuDataSvcs.getMenuItemById(menuId);
		});
  }
  ngOnDestroy(){
	  this.menuSubscription.unsubscribe();
  }
}
